import React, { forwardRef } from 'react';
import { Virtuoso, VirtuosoProps } from 'react-virtuoso';

interface VirtualizedListProps<T> extends Omit<VirtuosoProps<T, any>, 'itemContent'> {
  data: T[];
  itemContent: (index: number, item: T) => React.ReactNode;
  itemHeight?: number;
  overscan?: number;
  className?: string;
}

const VirtualizedList = forwardRef<
  HTMLDivElement,
  VirtualizedListProps<any>
>(({
  data,
  itemContent,
  itemHeight = 50,
  overscan = 5,
  className = '',
  ...props
}, ref) => {
  return (
    <div ref={ref} className={className}>
      <Virtuoso
        data={data}
        itemContent={itemContent}
        overscan={overscan}
        increaseViewportBy={{ top: 200, bottom: 200 }}
        {...props}
      />
    </div>
  );
});

VirtualizedList.displayName = 'VirtualizedList';

export default VirtualizedList;